import { Container, Menu } from './Styles'

const DashboardMenu = () => {
    return (
        <Container>
            <Menu to={'/sell/dashboard'} active={['sell', 'message-center']}>
                Sell
            </Menu>
            <Menu to={'/buy/dashboard'} active={'buy'}>
                Buy
            </Menu>
        </Container>
    )
}

export default DashboardMenu
